<template>
  <div class="popular-parlay">
    <div v-if="betType === 'Parlay'" class="parlays-container parlay">
      <div class="parlay-header" @click="viewMore(parlays, 'Parlay', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="title-wrapper-potential-return">
          <p class="header-title" v-html="$t('Popular.Parlays.' + (isTeaser(parlays.SelectionData) ? 'Teaser' : 'Leg'), { num: parlays.SelectionData.length })"></p>
          <span class="potential-return"><odds :potentialReturn="parlayPotentialReturn(parlays.BetCalculation.Calculation)" :na="'-'"></odds></span>
        </div>
        <p class="number-of-selections" v-html="$t('Popular.Parlays.Selections', { num: parlays.SelectionData.length })"></p>
      </div>
      <div class="content-wrapper" @click="viewMore(parlays, 'Parlay', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="parlay-selection parlay" v-for="(parlay, index) in parlays.SelectionData" :class="{'less-then-4-legs': parlays.SelectionData.length < 4}" :key="parlay.selections[0].idfoselection">
          <div class="leg-icon"></div>
          <div class="content">
            <div class="content-left">
              <span class="selection-name">{{ parlay.selections[0].name }} <handicap :selection="parlay.selections[0]"></handicap></span>
              <span class="market-name">{{ parlay.market.name }}</span>
              <span class="event-name" @click="goToEvent(parlay.market, 'popularparlays', parlays.SelectionData, 'Parlay', parlays.IDFWMarketGroup, undefined)">{{ isAmericanSport(parlay.market) }}</span>
            </div>
            <div class="content-right">
              <span class="potential-return">
                <odds v-if="parlays.BetCalculation.Calculation.PotentialReturns.PerSelection[parlay.selections[0].idfoselection].PotentialReturn"
                  :potentialReturn="parlays.BetCalculation.Calculation.PotentialReturns.PerSelection[parlay.selections[0].idfoselection].PotentialReturn" :na="'-'"></odds>
              </span>
              <span class="start-date">{{ formatDate(parlay.market.tsstart) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showViewMore && parlays.SelectionData.length > 3" class="view-more-container">
        <div class="leg-icon"></div>
        <div class="view-more">
          <button @click="viewMore(parlays, 'Parlay', 'popularparlays', parlays.IDFWMarketGroup)" v-html="parlays.SelectionData.length - 3 > 1 ? $t('Popular.Parlays.ViewMoreThenOne', { num: parlays.SelectionData.length - 3 }) : $t('Popular.Parlays.ViewMore', { num: parlays.SelectionData.length - 3 })"></button>
        </div>
      </div>
      <div class="add-to-betslip-wrapper">
        <div @click="addToBetslip(parlays.SelectionData, 'popularparlays', 'Parlay', parlays.IDFWMarketGroup)" class="add-to-betslip-button">
          <button>{{ $t('Popular.Parlays.AddToBetslip') }}</button>
          <p v-html="$t('Popular.Parlays.Potential.Return', { num: winning(parlays.BetCalculation.Calculation) || '-', stake: parlayStake})"></p>
        </div>
      </div>
    </div>
    <div v-if="betType === 'SGP'" class="parlays-container SGP" :key="'sgp-event-'+parlays.SelectionData[0].market.idfoevent">
      <div class="parlay-header" @click="viewMore(parlays, 'SGP', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="title-wrapper">
          <div class="sgp-title-wrapper">
            <span class="sgp-icon"></span>
            <p class="header-title" @click="goToEvent(parlays.SelectionData[0].market, 'popularparlays', parlays.SelectionData, 'SGP', parlays.IDFWMarketGroup, undefined)">{{ isAmericanSport(parlays.SelectionData[0].market) }}</p>
          </div>
          <div class="title-wrapper-potential-return">
            <span class="potential-return"><odds :potentialReturn="parlayPotentialReturn(parlays.BetCalculation.ProviderCalculation, 'SGP')" :na="'-'"></odds></span>
          </div>
        </div>
        <p class="number-of-selections" v-html="$t('Popular.Parlays.Selections', { num: parlays.SelectionData.length })"></p>
      </div>
      <div class="content-wrapper" @click="viewMore(parlays, 'SGP', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="parlay-selection SGP" v-for="(parlay, index) in parlays.SelectionData" :key="parlay.selections[0].idfoselection">
          <div class="leg-icon"></div>
          <div class="content-left">
            <span class="selection-name">{{ parlay.selections[0].name }} <handicap :selection="parlay.selections[0]"></handicap></span>
            <span class="market-name">{{ parlay.market.name }}</span>
          </div>
        </div>
      </div>
      <div v-if="showViewMore && parlays.SelectionData.length > 4" class="view-more-container">
        <div class="leg-icon"></div>
        <div class="view-more">
          <button @click="viewMore(parlays, 'SGP', 'popularparlays', parlays.IDFWMarketGroup)" v-html="parlays.SelectionData.length - 4 > 1 ? $t('Popular.Parlays.ViewMoreThenOne', { num: parlays.SelectionData.length - 4 }) : $t('Popular.Parlays.ViewMore', { num: parlays.SelectionData.length - 4 })"></button>
        </div>
      </div>
      <div class="add-to-betslip-wrapper">
        <div @click="addToBetslip(parlays.SelectionData, 'popularparlays', 'SGP', parlays.IDFWMarketGroup)" class="add-to-betslip-button">
          <button>{{ $t('Popular.Parlays.AddToBetslip') }}</button>
          <p v-html="$t('Popular.Parlays.Potential.Return', { num: winning(parlays.BetCalculation.ProviderCalculation, 'SGP'), stake: parlayStake })"></p>
        </div>
      </div>
    </div>
    <div v-if="betType === 'SGP+'" class="parlays-container SGPPlus">
      <div class="parlay-header" @click="viewMore(parlays, 'SGP+', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="title-wrapper">
          <div class="sgpplus-title-wrapper">
            <span v-if="sortedEventData(parlays.SelectionData)" class="sgp-plus-icon"></span>
            <p class="header-title" v-html="$t('Popular.Parlays.Number.Of.SGPPlus', {num: parlays.SelectionData.length})"></p>
          </div>
          <div class="title-wrapper-potential-return">
            <span class="potential-return"><odds :potentialReturn="parlayPotentialReturn(parlays.BetCalculation.CalculationXP)" :na="'-'"></odds></span>
          </div>
        </div>
        <div>
          <span class="number-of-selections" v-html="numberOfSGP(parlays.SelectionData).moreThanOne > 1 ? $t('Popular.Parlays.Number.Of.SGP.In.SGPPlus.MoreThenOne', {num: numberOfSGP(parlays.SelectionData).moreThanOne}) : $t('Popular.Parlays.Number.Of.SGP.In.SGPPlus', {num: numberOfSGP(parlays.SelectionData).moreThanOne})"></span>
          <span class="number-of-selections" v-if ="numberOfSGP(parlays.SelectionData).onlyOne > 0" v-html="numberOfSGP(parlays.SelectionData).onlyOne > 1 ? $t('Popular.Parlays.Number.Of.Selections.In.SGPPlus.MoreThenOne', {num: numberOfSGP(parlays.SelectionData).onlyOne}) : $t('Popular.Parlays.Number.Of.Selections.In.SGPPlus', {num: numberOfSGP(parlays.SelectionData).onlyOne})"></span>
        </div>
      </div>
      <div class="content-wrapper" @click="viewMore(parlays, 'SGP+', 'popularparlays', parlays.IDFWMarketGroup)">
        <div class="parlay-selection SGPPlus" v-for="(parlay, index) in sortedEventData(parlays.SelectionData)" :key="index+'-event-'+parlay[0].market.idfoevent">
          <div class="content-left" :class="{ 'has-more-than-2-legs': parlay.length > 2 }">
            <div class="SGP">
              <div class="leg-icon"></div>
              <div class="sgp-title">
                <span v-if="parlay.length > 1" class="sgp-icon"></span>
                <div class="title-with-return" :class="{ 'isSGP': parlay.length > 1 }">
                  <span @click="goToEvent(parlay[0].market, 'popularparlays', parlays.SelectionData, 'SGP+', parlays.IDFWMarketGroup, undefined)" class="event-name">{{ isAmericanSport(parlay[0].market) }}</span>
                  <span class="potential-return"><odds :potentialReturn="getPriceByIdfoSelection(parlays, parlay[0].selections[0].idfoselection)" :na="''"></odds></span>
                </div>
              </div>
            </div>
            <div v-for="par in parlay" class="sgp-selection" :key="'sgp-selection-'+par.selections[0].idfoselection">
              <div class="leg-icon"></div>
              <div class="selection-data-wrapper">
                <div class="selection-data">
                  <span class="selection-name">{{ par.selections[0].name }} <handicap :selection="par.selections[0]"></handicap></span>
                  <span class="market-name">{{ par.market.name }}</span>
                </div>
                <span class="potential-return" v-if="parlay.length < 2"><odds :potentialReturn="par.selections[0].price" :na="'-'"></odds></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showViewMore && parlays.SelectionData.length > 3" class="view-more-container">
        <div class="leg-icon"></div>
        <div class="view-more">
          <button @click="viewMore(parlays, 'SGP+', 'popularparlays', parlays.IDFWMarketGroup)" v-html="parlays.SelectionData.length - 3 > 1 ? $t('Popular.Parlays.ViewMoreThenOne', { num: parlays.SelectionData.length - 3 }) : $t('Popular.Parlays.ViewMore', { num: parlays.SelectionData.length - 3 })"></button>
        </div>
      </div>
      <div class="add-to-betslip-wrapper">
        <div @click="addToBetslip(parlays.SelectionData, 'popularparlays', 'SGP+', parlays.IDFWMarketGroup)" class="add-to-betslip-button">
          <button>{{ $t('Popular.Parlays.AddToBetslip') }}</button>
          <p v-html="$t('Popular.Parlays.Potential.Return', { num: winning(parlays.BetCalculation.CalculationXP) || '-', stake: parlayStake } )"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import BettingOffer from '@/components/mixins/BettingOffer'
import Screen from '@/components/mixins/Screen'
import Gtm from '@/components/mixins/Gtm'
import odds from './PopularParlayOdds.vue'
import handicap from './PopularParlayHcp.vue'
import teaserPriceType from '@/library/teaserPriceType'
import lib from '@/library'
import moment from 'moment'

export default {
  name: 'PopularParlay',
  components: { odds, handicap },
  mixins: [
    BettingOffer,
    Gtm,
    Screen
  ],
  props: [
    'parlays',
    'maxNumOfSelections',
    'showAll'
  ],
  data () {
    return {
      parlayStake: 10,
      activeIDFWMarketGroup: null,
      activeParlayBetType: null
    }
  },
  computed: {
    betType () {
      if (this.parlays.BetCalculation.CalculationXP) return 'SGP+'
      else if (this.parlays.BetCalculation.ProviderCalculation) return 'SGP'
      else return 'Parlay'
    },
    isSGP () {
      if (this.betType === 'SGP') return true

      return false
    },
    isPopularParlaysDialogActive () {
      return store.getters['overlayState/getPopularParlaysDialogState']
    },
    showViewMore () {
      return this.$route.name !== 'parlayzone'
    }
  },
  methods: {
    origin (parlay) {
      lib.personalization.popularParlays.getOrigin(parlay)
    },
    viewMore (parlay, betType, module, popularParlaysIDFWMarketGroup) {
      if (this.showViewMore) {
        let iDFWMarketGroup = popularParlaysIDFWMarketGroup || parlay.IDFWMarketGroup
        this.activeIDFWMarketGroup = iDFWMarketGroup
        this.activeParlayBetType = betType
        store.dispatch('overlayState/activatePopularParlaysDialogData', {parlay, betType, iDFWMarketGroup})
          .then(resp => {
            store.dispatch('overlayState/deactivatePopularParlaysDialogData', false)
            this.activeIDFWMarketGroup = null
            this.activeParlayBetType = null
          })
      }
    },
    winning (calculation, isSGP) {
      let potentialReturn = this.parlayPotentialReturn(calculation, isSGP)
      let winning = (potentialReturn - 1) * this.parlayStake
      winning = winning.toFixed(2)
      return winning
    },
    parlayPotentialReturn (calculation, isSGP) {
      return lib.personalization.popularParlays.parlayPotentialReturn(calculation, isSGP)
    },
    isTeaser (selectionData) {
      let priceTypes = selectionData.map(sd => sd.market.csvpricetypes.split(','))
      priceTypes = Vue._.flatten(priceTypes)
      priceTypes = Vue._.uniq(priceTypes)
      let pt = priceTypes && priceTypes.length === 1 && priceTypes[0]
      let isTeaser = !!pt && teaserPriceType.isTeaserPriceType(pt) && pt
      return isTeaser
    },
    formatDate (date) {
      return moment(date).format(this.dateFormats.dayAndTime)
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"
.popular-parlay
  width 100%
.popular_parlays_holder
  background var(--popular-parlays-holder-bgr)
  margin 0 5px 5px 0
  box-shadow none !important
  width auto
  @media mobile-big-and-below
    margin 0
  >>>.v-expansion-panel__container--active
    border-bottom 10px solid var(--popular-parlays-holder-bgr)
    @media mobile-big-and-below
      border-bottom 0
  >>>.v-expansion-panel__container--active
    .v-expansion-panel__header
      margin-bottom 0 !important
  >>>.v-expansion-panel__header
    border none !important
    height 43px
    padding 12px 8px
    .pp_header
      display flex
      align-items center
    .pp_icon
      background var(--pp-icon) 100% center no-repeat
      width 27px
      height 17px
      display inline-flex
      margin-right 10px
    .pp_title
      font-size 16px
      font-family 'Roboto Condensed Bold'
  >>>.v-expansion-panel__header__icon .v-icon
    color var(--popular-parlays-holder-openclose-icon-color) !important
  >>>.v-expansion-panel__body
    padding-left 5px
  .recomended-parlays
    background var(--popular-parlays-holder-bgr)
    display flex
    overflow-x auto
    margin-left 0
    overflow-y hidden
    padding-bottom 10px
    z-index 5
    .one-parlay-only
      width 100%
      margin-right 5px
      .parlays-container
        width 100%
      .popular-parlay
        .parlays-container
          .content-wrapper
            .parlay-selection
              .content
                width 98%
                @media mobile-big-and-below
                  width 94%
  .parlays-container.SGPPlus
    .title-wrapper
      display flex
      justify-content space-between
      .sgpplus-title-wrapper
        display flex
        cursor pointer
        width 80%
        text-overflow ellipsis
        white-space nowrap
        overflow hidden
        font-size 15px
        font-family: 'Roboto Condensed Bold'
        line-height 17.58px
        .sgp-plus-icon
          display: inline-block
          background var(--betslip-sgp-plus-icon)
          background-repeat: no-repeat
          background-size 100%
          width: var(--popular-parlay-sgp-plus-width)
          height: var(--popular-parlay-sgp-plus-height)
          margin-right: 3px
  .parlays-container.SGP
    .title-wrapper
      .sgp-title-wrapper
        display flex
        cursor pointer
        width 80%
        text-overflow ellipsis
        white-space nowrap
        overflow hidden
        font-size 15px
        font-family: 'Roboto Condensed Bold'
        line-height 17.58px
        .header-title
          display inline-block
          cursor pointer
          width 81%
          text-overflow ellipsis
          white-space nowrap
          overflow hidden
          font-size 15px
          font-family: 'Roboto Condensed Bold'
          line-height 17.58px
        .sgp-icon
          display: inline-block
          background var(--betslip-sgp-icon)
          background-repeat: no-repeat
          background-size 100%
          width: var(--popular-parlay-sgp-width)
          height: var(--popular-parlay-sgp-height)
          margin-right: 3px
  .parlays-container.SGPPlus
    display flex
    flex-direction column
    .view-more-container
      .view-more
        padding-left 9px
  .parlays-container.parlay
    .parlay-header
      .header-title
        margin-bottom 0
    .content-wrapper
      flex 1
  .parlays-container
    width 290px
    height 270px
    margin-right: 10px
    background var(--popular-parlays-content-bgr)
    color var(--popular-parlays-content-color)
    border-radius var(--popular-parlays-border-radius)
    overflow hidden
    display flex
    flex-direction column
    border var(--popular-parlays-border)
    .parlay-header
      padding 5px
      border-top-left-radius var(--popular-parlays-border-radius)
      border-top-right-radius var(--popular-parlays-border-radius)
      background: var(--popular-parlays-header-bgr)
      color var(--popular-parlays-header-color)
      height 48px
      font-size 15px
      font-family: 'Roboto Condensed Bold'
      line-height 17.58px
      display flex
      flex-direction column
      justify-content space-around
      cursor pointer
      .title-wrapper
        display flex
        justify-content space-between
      .header-title
        margin-bottom 0px
      .number-of-selections
        font-size 11px
        font-family: 'Roboto Condensed'
        line-height 12.89px
        text-transform uppercase
      .title-wrapper-potential-return
        display: flex
        justify-content: space-between
    .content-wrapper
      display flex
      flex-direction column
      overflow hidden
      flex 1
      cursor pointer
      .parlay-selection
        display flex
        padding-left 5px
      .parlay-selection.parlay
        .content
          display flex
          border-bottom 1px solid var(--popular-parlays-content-borders-color)
          width 94%
          margin-left 5px
          .content-left
            padding-left 0
            .event-name
              font-size 11px
              line-height 13px
      .parlay-selection.parlay
        &.less-then-4-legs
          padding-bottom 5px
          .leg-icon:after
            height 43px
      .parlay-selection.SGP
        padding-bottom 3px
      .parlay-selection.SGPPlus
        .content-left
          &.has-more-than-2-legs
            .SGP
              padding-bottom 5px
            .sgp-selection
              padding-bottom 5px
      .parlay-selection.SGPPlus
        .content-left
          width 100%
          padding-left 0
          .sgp-selection
            display flex
            align-items: center
            justify-content space-between
            width 100%
            .selection-data-wrapper
              display flex
              margin-bottom 5px
              justify-content space-between
              width 93%
              .selection-data
                display flex
                flex-direction column
              .potential-return
                font-size 14px
                line-height 11px
                font-family: 'Roboto Condensed Bold'
                padding-right 5px
          .SGP
            width 100%
            display flex
            justify-content space-between
            .sgp-title
              width 93%
              display flex
              margin-bottom 5px
              .title-with-return.isSGP
                .event-name
                  width 76%
                  font-size 12px
              .title-with-return
                display flex
                justify-content space-between
                width 86%
                align-items baseline
                font-size 14px
                line-height 11px
                font-family: 'Roboto Condensed Bold'
                .event-name
                  width 100%
                  @media mobile-big-and-below
                    line-height 15px
                .potential-return
                  font-size 14px
                  line-height 11px
                  font-family: 'Roboto Condensed Bold'
                  padding-right 4px
      .parlay-selection
        width 100%
        .leg-icon
          width: 12px
          height: 12px
          background-position: center
          background-repeat: no-repeat
          background-size: contain
          background-color: transparent
          background-image: var(--popular-parlay-leg-icon)
          margin-top: -2px
          z-index 100
          align-self center
        .leg-icon:after
          content ''
          display block
          height 30px
          width 1px
          background transparent
          border-left var(--popular-parlay-leg-line)
          margin-left 6px
          margin-top 8px
        .content-left
          display flex
          flex-direction column
          width 68%
          padding: 5px 0 0 5px
          .selection-name
            font-size 14px
            font-family: 'Roboto Condensed Bold'
            line-height 13px
            color: var(--popular-parlay-selection-color)
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
          .market-name
            font-size 11px
            font-family: 'Roboto Condensed'
            line-height 15px
            text-transform uppercase
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
            color var(--popular-parlay-marketname-color)
          .event-name
            color var(--popular-parlay-eventname-color)
            display inline-block
            cursor pointer
            text-overflow ellipsis
            white-space nowrap
            overflow hidden
            line-height 13px
            font-family: 'Roboto Condensed Bold'
            font-size 11px
          .sgp-icon
            display: inline-block
            background var(--betslip-sgp-icon)
            background-repeat: no-repeat
            background-size 100%
            width: var(--popular-parlay-sgp-width)
            height: var(--popular-parlay-sgp-height)
            margin-right: 2px
        .content-right
          display flex
          flex-direction column
          width 32%
          justify-content: space-between
          align-items: flex-end
          padding 5px 5px 0 0
          .potential-return
            font-size 14px
            line-height 11px
            font-family: 'Roboto Condensed Bold'
            color var(--popular-parlay-potntial-return-color)
          .start-date
            font-size 11px
            line-height 12px
            font-family: 'Roboto Condensed'
            text-transform uppercase
      .parlay-selection.parlay
        .leg-icon:after
          height 40px
      .parlay-selection.parlay:last-child
        .leg-icon:after
          display none
      .parlay-selection.parlay:nth-child(3)
        padding-bottom 10px
      .parlay-selection.SGP:last-child
        .leg-icon:after
          display none
      .parlay-selection.SGPPlus:last-child
        .content-left > *:last-child
          .leg-icon:after
            display none
      .parlay-selection.SGPPlus:nth-child(1)
        .content-left > *:nth-child(4)
          .leg-icon:after
            height 40px
        .content-left
          .sgp-selection:nth-child(4)
            margin-bottom 30px
    .view-more-container
      display flex
      align-items baseline
      padding-left 5px
      margin-bottom 5px
      .leg-icon
        width: 12px
        height: 12px
        background-position: center
        background-repeat: no-repeat
        background-size: contain
        background-color: transparent
        background-image: var(--popular-parlay-leg-icon)
        margin-top: -2px
        z-index 100
        align-self center
      .view-more
        color var(--popular-parlay-view-more)
        font-size 11px
        font-family: 'Roboto Condensed Bold'
        display flex
        padding-left 5px
  .add-to-betslip-wrapper
    display flex
    justify-content center
    padding-bottom 10px
    .add-to-betslip-button
      height 42px
      width 90%
      border-radius var(--popular-parlay-primary-btn-border-radius)
      background var(--popular-parlay-primary-btn-bgr)
      color var(--popular-parlay-primary-btn-accent-color)
      border var(--popular-parlay-primary-btn-border)
      display flex
      flex-direction column
      align-items center
      justify-content center
      cursor pointer
      button
        line-height 17.58px
        font-family: 'Roboto Condensed Bold'
        font-size 15px
        cursor pointer
      p
        text-align center
        text-transform uppercase
        font-size 11px
        line-height 12.89px
        font-family: 'Roboto Condensed'
        color var(--popular-parlay-primary-btn-color)
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/PopularParlay.vue